export default __webpack_public_path__ + "static/media/114.e2700de3.png";